import {
  Close,
  Cupom,
  IconCreditCard,
  IconPix,
  IconSecurity,
  IconTicketPayment,
} from '@/assets/icons';
import { Button, Modal } from '@/components';
import { defaultModalTheme, pixTheme } from '@/components/Modal/modalTheme';
import { TabTypePayments } from '@/components/TabTypePayments';
import { CreditCardC6PaymentRequestContent } from '@/features/checkout/components/CreditCardC6PaymentRequestContent';
import { CreditCardPaymentContent } from '@/features/checkout/components/CreditCardPaymentContent';
import { CreditCardPaymentRequestContent } from '@/features/checkout/components/CreditCardPaymentRequestContent';
import { NoCardContent } from '@/features/checkout/components/NoCardContent';
import { PaymentErroContent } from '@/features/checkout/components/PaymentError';
import { PaymentNotMadeContent } from '@/features/checkout/components/PaymentNotMade';
import { PixPaymentContent } from '@/features/checkout/components/PixPaymentContent';
import { TicketPaymentContent } from '@/features/checkout/components/TicketPaymentContent';
import { CardCheckout, ShowModalPayment } from '@/features/checkout/types';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';
import Cart from '@/features/core/cart/components/Cart';
import { EventTicketSite } from '@/features/event/screens/Event';
import { ConfirmDeleteCreditCardContent } from '@/features/profile/components/ConfirmDeleteCreditCardContent';
import { classNames } from '@/helpers/common';
import CardClient from '@/model/CardClient';
import Payment from '@/model/Payment';
import PaymentType from '@/model/PaymentType';
import dayjs from 'dayjs';
import React, { ReactNode, useEffect, useState } from 'react';

interface PaymentTab {
  text: string;
  icon: React.ReactNode;
  type: PaymentType;
}

interface PaymentContent {
  content: React.ReactNode;
  type: PaymentType;
}
interface PaymentTabAndContent {
  tabs: PaymentTab[];
  contents: PaymentContent[];
}

interface StateProps {
  cart: Cart;
  payment: Payment;
  paymentType?: PaymentType;
  card?: CardCheckout;
  c6CreditCheckout: boolean;
  cards: CardClient[];
  cameFromAdm: boolean;
  visible: boolean;
  title: ReactNode | string;
  shouldShowModal: ShowModalPayment;
  boleto: string;
  barcode: string;
  qrCodeImage: string;
  qrCodeText: string;
  messageError?: string;
  messagePayment?: string;
}
interface DispatchProps {
  toCurrency: (value: number) => string;
  onChangeCreditCard: (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  onCardSelected: (id: string) => void;
  onShowDeleteCreditCard: (id: string) => void;
  checkoutValidateCreditCard: () => void;
  onAddCard: () => void;
  onIncrementTicket: (item: EventTicketSite) => void;
  onDecrementTicket: (item: EventTicketSite) => void;
  onRemoveCupom: () => void;
  onSetPaymentType: (type: PaymentType) => void;
  onSendOrder: () => void;
  onToggle: () => void;
  onGoToTickets: () => void;
  onCopyText: (text: string) => void;
  onDeleteCreditCard: () => void;
}

type CheckoutContainerProps = StateProps & DispatchProps;

export const CheckoutContainer: React.FC<CheckoutContainerProps> = ({
  cart,
  toCurrency,
  payment,
  paymentType,
  card,
  c6CreditCheckout,
  onChangeCreditCard,
  cards,
  onCardSelected,
  onShowDeleteCreditCard,
  onDeleteCreditCard,
  checkoutValidateCreditCard,
  onAddCard,
  // cameFromAdm,
  // onIncrementTicket,
  // onDecrementTicket,
  onRemoveCupom,
  onSetPaymentType,
  onSendOrder,
  visible,
  title,
  onToggle,
  shouldShowModal,
  onGoToTickets,
  boleto,
  barcode,
  onCopyText,
  qrCodeImage,
  qrCodeText,
  messageError,
  messagePayment,
}) => {
  const [paymentTabAndContent, setPaymentTabAndContent] = useState<PaymentTabAndContent>({
    tabs: [],
    contents: [],
  });
  const [showCartResume, setShowCartResume] = useState(false);
  const mountTotalValue = (): string => {
    let value = cart.totalValueWithFee;
    if (cart.fractional) {
      value = cart.fractional.remainingValue;
    } else if (cart.discountCoupon) {
      value -= cart.discountCoupon.discount;
    } else if (cart.voucher) {
      value -= cart.voucher.value;
    }
    return toCurrency(value);
  };

  const mountPayment = (): void => {
    const tabsAndContents: PaymentTabAndContent = {
      tabs: [],
      contents: [],
    };
    if (payment && payment.fees) {
      if (payment.allowPaymentCredit) {
        tabsAndContents.tabs.push({
          text: 'Cartão de Crédito',
          icon: (
            <IconCreditCard
              className={classNames(
                paymentType === PaymentType.CREDIT_CARD ? 'text-white' : 'text-neutro-w-600',
                'mb-[16px] h-[15px]',
              )}
            />
          ),
          type: PaymentType.CREDIT_CARD,
        });
        tabsAndContents.contents.push({
          content: (
            <div key={1} className="mt-[28px]">
              <div className="flex">
                <IconCreditCard
                  className={classNames(
                    paymentType === PaymentType.CREDIT_CARD ? 'text-black' : 'text-neutro-w-600',
                    'mt-[10px] h-[20px]',
                  )}
                />
                <h1 className="ml-[10px] font-dmsans font-semibold text-neutro-b-400 text-[22px] mb-[10px]">
                  {card && c6CreditCheckout ? (
                    <span>Informe a Parcela</span>
                  ) : (
                    <span>Selecione o cartão</span>
                  )}
                </h1>
              </div>

              {card && c6CreditCheckout && (
                <CreditCardC6PaymentRequestContent
                  payment={payment}
                  totalValue={cart.originalValueWithPaymentFee}
                  toCurrency={toCurrency}
                  onChange={onChangeCreditCard}
                  card={card}
                />
              )}

              {card && !c6CreditCheckout && (
                <CreditCardPaymentRequestContent
                  cards={cards}
                  payment={payment}
                  totalValue={cart.originalValueWithPaymentFee}
                  toCurrency={toCurrency}
                  card={card}
                  onCardSelected={onCardSelected}
                  onShowDeleteCreditCard={onShowDeleteCreditCard}
                  onChange={onChangeCreditCard}
                  validateCreditCard={checkoutValidateCreditCard}
                />
              )}
              {!c6CreditCheckout && (
                <Button
                  type="button"
                  title="+ Adicionar novo cartão"
                  buttonStyle="dashed"
                  size="xlg"
                  className="mt-[24px] w-full lg:w-[411px]"
                  onClick={onAddCard}
                />
              )}
            </div>
          ),
          type: PaymentType.CREDIT_CARD,
        });
      }

      if (payment.allowPaymentBankSlip) {
        tabsAndContents.tabs.push({
          text: 'Boleto',
          icon: (
            <IconTicketPayment
              className={classNames(
                paymentType === PaymentType.BANK_SLIP ? 'text-white' : 'text-neutro-w-600',
                'mb-[16px] h-[22px]',
              )}
            />
          ),
          type: PaymentType.BANK_SLIP,
        });

        tabsAndContents.contents.push({
          content: (
            <div key={3} className="md:w-[470px] mt-[28px]">
              <IconTicketPayment className="text-neutro-b-400 h-[30px] mb-[16px]" />
              <h4 className="font-dmsans font-bold text-neutro-b-400 text-base mb-[12px]">
                O ingresso já é quase seu!
              </h4>
              <p className="font-dmsans text-base font-normal text-neutro-w-600 mb-[24px]">
                Ao clicar em <strong>“Finalizar compra”</strong>, o boleto aparecerá na tela e você
                terá 3 dias para efetuar o pagamento.
              </p>
              <div className="flex justify-start items-center">
                <div className="w-[26px] h-[5px] bg-neutro-w-600 mr-2"></div>
                <IconSecurity className="text-neutro-w-600 h-[15px]" />
              </div>
              <p className="font-dmsans text-base font-normal text-neutro-w-600">
                Pagamento 110% Seguro
              </p>
            </div>
          ),
          type: PaymentType.BANK_SLIP,
        });
      }

      if (payment.allowPaymentPIX) {
        tabsAndContents.tabs.push({
          text: 'PIX',
          icon: (
            <IconPix
              className={classNames(
                paymentType === PaymentType.PIX ? 'text-white' : 'text-neutro-w-600',
                'mb-[16px] h-[20px]',
              )}
            />
          ),
          type: PaymentType.PIX,
        });

        tabsAndContents.contents.push({
          content: (
            <div key={4} className="md:w-[411px] mt-[28px]">
              <IconPix className="text-neutro-b-400 h-[30px] mb-[16px]" />
              <h4 className="font-dmsans font-bold text-neutro-b-400 text-base mb-[12px]">
                O ingresso já é quase seu!
              </h4>
              <p className="font-dmsans text-base font-normal text-neutro-w-600 mb-[24px]">
                Ao clicar em <strong>“Finalizar compra”</strong>, o código PIX aparecerá na tela
                para você poder fazer o pagamento instantâneo.
              </p>
              <div className="flex justify-start items-center">
                <div className="w-[26px] h-[5px] bg-neutro-w-600 mr-2"></div>
                <IconSecurity className="text-neutro-w-600 h-[15px]" />
              </div>
              <p className="font-dmsans text-base font-normal text-neutro-w-600">
                Pagamento 110% Seguro
              </p>
            </div>
          ),
          type: PaymentType.PIX,
        });
      }
      setPaymentTabAndContent(tabsAndContents);
    }
  };

  useEffect(() => {
    if (payment) {
      mountPayment();
    }
  }, [payment]);

  useEffect(() => {
    if (card) {
      mountPayment();
    }
  }, [card]);

  useEffect(() => {
    setTimeout(() => {
      const element = window.document.getElementById('selectPrincipal') as HTMLElement;
      element.scrollIntoView();
    }, 200);
  }, []);

  return (
    <AuthWrapper isHomepage={false}>
      <div
        className="w-full max-w-[760px] mx-auto px-4"
        style={{ paddingTop: '16px', paddingBottom: '6rem' }}
      >
        <div className="flex flex-col gap-5">
          <section
            className="mb-[20px] bg-white rounded-[18px] border border-[#d9e4f2] shadow-sm overflow-hidden"
            id="selectPrincipal"
          >
            <button
              type="button"
              onClick={() => setShowCartResume(!showCartResume)}
              className="w-full flex items-center justify-between gap-4 p-5 text-left bg-white hover:bg-[#f4f8fc] transition-colors border-l-4 border-[#1B4880]"
            >
              <div className="min-w-0">
                <h2 className="font-dmsans font-bold text-[#1B4880] text-[24px] leading-[30px]">
                  Resumo da compra
                </h2>

                <p className="font-dmsans text-sm text-neutro-w-600 leading-[22px]">
                  {cart.amountItens} item(s) selecionado(s)
                </p>
              </div>

              <div className="flex flex-col items-end gap-1">
                <strong className="font-dmsans text-[18px] text-[#1B4880] whitespace-nowrap">
                  {mountTotalValue()}
                </strong>
                <span className="font-dmsans font-bold text-sm text-[#1B4880] whitespace-nowrap">
                  {showCartResume ? 'Ocultar' : 'Ver detalhes'}
                </span>
              </div>
            </button>

            {showCartResume && (
              <div className="px-5 pb-5 border-t border-[#d9e4f2] bg-[#f8fbff]">
                <p className="font-dmsans text-sm font-normal text-neutro-w-600 leading-[22px] mt-4 mb-4">
                  Ingressos do pedido
                </p>

                <div className="w-full">
                  {cart.events.map(event => (
                    <div
                      key={event.id}
                      className="cart-item w-full rounded-2xl bg-white border border-neutro-w-200 p-4"
                    >
                      <header className="grid grid-cols-[82px_1fr] items-center gap-4">
                        <div className="relative">
                          <img
                            className="w-[82px] h-[82px] object-cover rounded-xl"
                            src={event.imageDetailUrl}
                            alt="Event"
                          />
                          <div className="absolute rounded-md top-0 w-full h-full bg-card-default hover:bg-card-hover transition-all duration-200 ease-in-out"></div>
                        </div>
                        <div className="text-left">
                          <h4 className="text-neutral-b-400 font-dmsans font-semibold text-[16px] sm:text-[18px] leading-[22px]">
                            {event.name}
                          </h4>
                          <div className="flex flex-wrap items-center text-base">
                            <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[14px]">
                              {dayjs(event.startDate).locale('pt-br').format('DD MMM')}{' '}
                            </span>
                            <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full"></span>
                            <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[14px]">
                              {dayjs(event.startDate).format('HH:mm')}
                            </span>
                            <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full"></span>
                            <span className="font-dmsans font-normal text-neutro-w-600 text-[12px] sm:text-[14px]">
                              {event.address.city}/{event.address.state}
                            </span>
                          </div>
                        </div>
                      </header>

                      <div className="mt-4 space-y-2">
                        {event.sections &&
                          event.sections.length > 0 &&
                          event.sections.map(section => (
                            <div key={`empty-tag-${section.section.id}`} className="space-y-2">
                              {section.tickets &&
                                section.tickets.length > 0 &&
                                section.tickets.map(ticket => {
                                  const resumeTicket = ticket as EventTicketSite & {
                                    amount?: number;
                                    quantity?: number;
                                    qtd?: number;
                                    name?: string;
                                    ticket?: { name?: string };
                                  };
                                  const ticketName =
                                    resumeTicket.name ||
                                    resumeTicket.ticket?.name ||
                                    section.section.name;
                                  const ticketQuantity =
                                    resumeTicket.amount ||
                                    resumeTicket.quantity ||
                                    resumeTicket.qtd ||
                                    resumeTicket.quantity ||
                                    resumeTicket.qtd ||
                                    1;

                                  return (
                                    <div
                                      key={ticket.id + ticket.isHalfPrice}
                                      className="flex items-center justify-between gap-4 rounded-xl bg-[#eef5fb] px-4 py-3 border border-[#d9e4f2]"
                                    >
                                      <span className="font-dmsans font-semibold text-[16px] text-neutro-b-400">
                                        {ticketName}
                                      </span>
                                      <span className="inline-flex min-w-[34px] h-[28px] items-center justify-center rounded-full bg-white border border-[#d9e4f2] font-dmsans font-bold text-sm text-[#1B4880]">
                                        {ticketQuantity}x
                                      </span>
                                    </div>
                                  );
                                })}
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="w-full text-left mt-4 rounded-2xl bg-white border border-neutro-w-200 p-4">
                  <div className="mb-[20px]">
                    {cart.discountCoupon && (
                      <div className="flex justify-between items-center mt-5">
                        <div className="flex justify-start items-center">
                          <img src={Cupom} alt={cart.discountCoupon.name} />
                          <span className="uppercase ml-3 mr-12">{cart.discountCoupon.code}</span>
                        </div>
                        <a
                          onClick={() => onRemoveCupom()}
                          className="text-neutro-b-400 cursor-pointer"
                        >
                          <img src={Close} alt="fechar" className="fill-neutro-b-400" />
                        </a>
                      </div>
                    )}
                    {cart.voucher && (
                      <div className="flex justify-between items-center mt-5">
                        <div className="flex justify-start items-center">
                          <img src={Cupom} alt={cart.voucher.code} />
                          <span className="uppercase ml-3 mr-12">{cart.voucher.code}</span>
                        </div>
                        <a
                          onClick={() => onRemoveCupom()}
                          className="text-neutro-b-400 cursor-pointer"
                        >
                          <img src={Close} alt="fechar" className="fill-neutro-b-400" />
                        </a>
                      </div>
                    )}
                  </div>

                  <div className="flex justify-between items-center mb-2">
                    <div className="font-dmsans text-sm text-neutro-w-600">Total de itens</div>
                    <div className="font-dmsans text-sm font-bold text-neutro-b-400">
                      {cart.amountItens}
                    </div>
                  </div>

                  {cart.fractional?.allowFractionalPayment && (
                    <>
                      <div className="flex justify-between items-center mb-1">
                        <div className="text-heading font-dmsans font-normal">
                          Total:{' '}
                          <span className="font-bold">
                            {toCurrency(cart.originalValueWithPaymentFee)}
                          </span>
                        </div>
                        <div className="text-heading font-dmsans font-normal">
                          Pago:{' '}
                          <span className="font-bold">
                            {toCurrency(cart.fractional.paidAmount)}
                          </span>
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-2">
                        <div className="text-heading font-dmsans font-normal">
                          Restante:{' '}
                          <span className="font-bold">
                            {toCurrency(cart.fractional.remainingValue)}
                          </span>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="flex justify-between items-center mb-2">
                    <div className="font-dmsans text-sm text-neutro-w-600">Subtotal</div>
                    <div className="font-dmsans text-sm font-bold text-neutro-b-400">
                      {cart.fractional
                        ? toCurrency(cart.fractional.remainingValue)
                        : toCurrency(cart.totalValue)}
                    </div>
                  </div>

                  {cart.discountCoupon && (
                    <div className="flex justify-between items-center mb-1">
                      <div className="text-heading font-dmsans font-normal">
                        Desconto:{' '}
                        <span className="font-bold">
                          - {toCurrency(cart.discountCoupon.discount)}
                        </span>
                      </div>
                    </div>
                  )}

                  {cart.voucher && (
                    <div className="flex justify-between items-center mb-1">
                      <div className="text-heading font-dmsans font-normal">
                        Desconto:{' '}
                        <span className="font-bold">- {toCurrency(cart.voucher.value)}</span>
                      </div>
                    </div>
                  )}

                  <div className="flex justify-between items-center mb-2">
                    <div className="font-dmsans text-sm text-neutro-w-600">Taxa</div>
                    <div className="font-dmsans text-sm font-bold text-neutro-b-400">
                      {toCurrency(cart.totalValueWithFee - cart.totalValue)}
                    </div>
                  </div>

                  <hr className="my-5" />

                  <div className="flex justify-between items-center rounded-xl bg-[#1B4880] px-4 py-3">
                    <div className="font-dmsans text-base font-bold text-white">Total</div>
                    <div className="font-dmsans text-[20px] font-bold text-white">
                      {mountTotalValue()}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </section>
          {/* <section
            className="mb-[20px] bg-white rounded-xl border border-neutro-w-200 shadow-sm p-[18px]"
            id="selectPrincipal"
          >
            <h2 className="font-dmsans font-bold text-neutro-b-400 text-[24px] leading-[32px]">
              Resumo da compra
            </h2>
            <p className="font-dmsans text-sm font-normal text-neutro-w-600 leading-[22px] mb-4">
              Confira os itens antes de finalizar
            </p>
            <div className="w-full">
              {cart.events.map(event => (
                <div
                  key={event.id}
                  style={{ paddingTop: '10px' }}
                  className="cart-item w-full border-b border-neutro-w-200 pb-4"
                >
                  <header className="grid grid-cols-[96px_1fr] items-center gap-4">
                    <div className="relative">
                      <img className="w-[96px] rounded-md" src={event.imageDetailUrl} alt="Event" />
                      <div className="absolute rounded-md top-0 w-full h-full bg-card-default hover:bg-card-hover transition-all duration-200 ease-in-out"></div>
                    </div>
                    <div className="text-left">
                      <h4 className="text-neutral-b-400 font-dmsans font-semibold text-[16px] sm:text-[18px] leading-[22px]">
                        {event.name}
                      </h4>
                      <div className="flex items-center text-base ">
                        <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                          {dayjs(event.startDate).locale('pt-br').format('DD MMM')}{' '}
                        </span>
                        <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full"></span>
                        <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                          {dayjs(event.startDate).format('HH:mm')}
                        </span>
                        <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full text-[12px] sm:text-[18px]"></span>
                        <span className="font-dmsans font-normal text-neutro-w-600">
                          {event.address.city}/{event.address.state}
                        </span>
                      </div>
                    </div>
                  </header>
                  <div>
                    <>
                      {event.sections &&
                        event.sections.length > 0 &&
                        event.sections.map(section => (
                          <div key={`empty-tag-${section.section.id}`}>
                            {section.tickets &&
                              section.tickets.length > 0 &&
                              section.tickets.map(ticket => (
                                <TicketIncrementResume
                                  key={ticket.id + ticket.isHalfPrice}
                                  item={ticket}
                                  cameFromAdm={cameFromAdm}
                                  increment={onIncrementTicket}
                                  decrement={onDecrementTicket}
                                />
                              ))}
                          </div>
                        ))}
                    </>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-full text-left">
              <div className="mb-[20px]">
                {cart.discountCoupon && (
                  <div className="flex justify-between items-center mt-5">
                    <div className="flex justify-start items-center">
                      <img src={Cupom} alt={cart.discountCoupon.name} />
                      <span className="uppercase ml-3 mr-12">{cart.discountCoupon.code}</span>
                    </div>
                    <a onClick={() => onRemoveCupom()} className="text-neutro-b-400 cursor-pointer">
                      <img src={Close} alt="fechar" className="fill-neutro-b-400" />
                    </a>
                  </div>
                )}
                {cart.voucher && (
                  <div className="flex justify-between items-center mt-5">
                    <div className="flex justify-start items-center">
                      <img src={Cupom} alt={cart.voucher.code} />
                      <span className="uppercase ml-3 mr-12">{cart.voucher.code}</span>
                    </div>
                    <a onClick={() => onRemoveCupom()} className="text-neutro-b-400 cursor-pointer">
                      <img src={Close} alt="fechar" className="fill-neutro-b-400" />
                    </a>
                  </div>
                )}
              </div>
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Total de itens: <span className="font-bold">{cart.amountItens}</span>
                </div>
              </div>

              {cart.fractional?.allowFractionalPayment && (
                <>
                  <div className="flex justify-between items-center mb-1">
                    <div className="text-heading font-dmsans font-normal">
                      Total:{' '}
                      <span className="font-bold">
                        {toCurrency(cart.originalValueWithPaymentFee)}
                      </span>
                    </div>
                    <div className="text-heading font-dmsans font-normal">
                      Pago:{' '}
                      <span className="font-bold">{toCurrency(cart.fractional.paidAmount)}</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <div className="text-heading font-dmsans font-normal">
                      Restante:{' '}
                      <span className="font-bold">
                        {toCurrency(cart.fractional.remainingValue)}
                      </span>
                    </div>
                  </div>
                </>
              )}
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Sub total:{' '}
                  <span className="font-bold">
                    {cart.fractional
                      ? toCurrency(cart.fractional.remainingValue)
                      : toCurrency(cart.totalValue)}
                  </span>
                </div>
              </div>
              {cart.discountCoupon && (
                <div className="flex justify-between items-center mb-1">
                  <div className="text-heading font-dmsans font-normal">
                    Desconto:{' '}
                    <span className="font-bold">- {toCurrency(cart.discountCoupon.discount)}</span>
                  </div>
                </div>
              )}
              {cart.voucher && (
                <div className="flex justify-between items-center mb-1">
                  <div className="text-heading font-dmsans font-normal">
                    Desconto: <span className="font-bold">- {toCurrency(cart.voucher.value)}</span>
                  </div>
                </div>
              )}
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Taxa:{' '}
                  <span className="font-bold">
                    {toCurrency(cart.totalValueWithFee - cart.totalValue)}
                  </span>
                </div>
              </div>
              <hr className="my-5" />
              <div className="flex justify-between items-center mb-1">
                <div className="text-heading font-dmsans font-normal">
                  Valor total: <span className="font-bold">{mountTotalValue()}</span>
                </div>
              </div>
            </div>
          </section> */}

          <section className="mb-[20px] bg-white rounded-[18px] border border-[#d9e4f2] shadow-sm p-5 border-l-4 border-l-[#1B4880]">
            <h2 className="font-dmsans font-bold text-[#1B4880] text-[24px] leading-[30px]">
              Pagamento
            </h2>
            <p className="font-dmsans text-sm font-normal text-neutro-w-600 leading-[22px]">
              Escolha uma forma de pagamento para concluir
            </p>
            <div className="mt-[20px]">
              <TabTypePayments
                typePayment={paymentType}
                onSetTypePayment={onSetPaymentType}
                tabs={paymentTabAndContent.tabs}
                contents={paymentTabAndContent.contents}
              />
              <div className="w-full mt-[24px]">
                <Button
                  type="submit"
                  title={`Finalizar compra de ${toCurrency(cart.totalValueWithPaymentFee)}`}
                  buttonStyle="primary"
                  size="xlg"
                  className="w-full mb-[25px]"
                  onClick={onSendOrder}
                  disabled={paymentType === undefined}
                />
              </div>
            </div>
          </section>
        </div>
        <Modal
          visible={visible}
          title={title}
          onSetVisible={onToggle}
          actions={[]}
          theme={ShowModalPayment.PIX_PAYMENT ? pixTheme : defaultModalTheme}
          className={ShowModalPayment.PIX_PAYMENT ? 'md:w-[1360px]' : 'md:w-[750px]'}
          showCloseButton={true}
        >
          {
            {
              [ShowModalPayment.CREDIT_CARD_PAYMENT]: (
                <CreditCardPaymentContent onGoToTickets={onGoToTickets} />
              ),
              [ShowModalPayment.TICKET_PAYMENT]: (
                <TicketPaymentContent boleto={boleto} barcode={barcode} onCopyText={onCopyText} />
              ),
              [ShowModalPayment.PIX_PAYMENT]: (
                <PixPaymentContent
                  qrCodeImage={qrCodeImage}
                  qrCodeText={qrCodeText}
                  onCopyText={onCopyText}
                />
              ),
              [ShowModalPayment.CONFIRM_DELETE_CREDIT_CARD_PAYMENT]: (
                <ConfirmDeleteCreditCardContent
                  onCancelConfirm={onToggle}
                  onOkConfirm={onDeleteCreditCard}
                />
              ),
              [ShowModalPayment.PAYMENT_ERROR]: (
                <PaymentErroContent
                  messageError={messageError}
                  onOkConfirm={() => {
                    onToggle();
                    onSendOrder();
                  }}
                />
              ),
              [ShowModalPayment.PAYMENT_NOTMADE]: (
                <PaymentNotMadeContent messagePayment={messagePayment} onOkConfirm={onToggle} />
              ),
              [ShowModalPayment.NO_CARD]: <NoCardContent goAddCard={onAddCard} />,
            }[shouldShowModal]
          }
        </Modal>
      </div>
    </AuthWrapper>
  );
};
